import isEmpty from "lodash.isempty";
import { useEffect, useState } from "react";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { userRoles } from "../../../constants";
import useStepper from "../../../hooks/useStepper";
import Loader from "../../generic-components/loader";
import { schemeTypeNames } from "../../../constants/multiForm";
import { mmmUniversalRedirection } from "../../../helpers";
import { newApplicationFormPath } from "../../../constants/path";

const EmployeeRoutes = () => {
  const { personalDetails } = useStepper();
  const [isAuthorisedUser, setIsAuthorisedUser] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const { pathname } = useLocation();

  const handleAuthorisation = () => {
    const isManagePlanPath = pathname.includes(
      newApplicationFormPath.MANAGE_MY_SHARED_COST_AVC
    );
    if (personalDetails?.new_journey && !isManagePlanPath) {
      console.log(
        "handleAuthorisation:: Redirecting to MMM dashboard for new journey user"
      );
      let mmmPath = "/employee/dashboard";
      const isSharedCostExist = personalDetails?.active_schemes?.find(
        (scheme) =>
          scheme.scheme_type_name?.toLowerCase() ===
          schemeTypeNames.SHARED_COST_AVC?.toLowerCase()
      );
      const isStandardExist = personalDetails?.active_schemes?.find(
        (scheme) =>
          scheme.scheme_type_name?.toLowerCase() ===
          schemeTypeNames.STANDARD_AVC?.toLowerCase()
      );
      if (isSharedCostExist) {
        mmmPath = "/scavc/home";
      }
      if (!isSharedCostExist && isStandardExist) {
        mmmPath = "/savc/home";
      }
      mmmUniversalRedirection(personalDetails?.sub_domain, mmmPath);
      return;
    }
    if (
      !isEmpty(personalDetails) &&
      !personalDetails.backend_user &&
      !personalDetails?.current_organisation_roles?.includes(
        userRoles.ORGANISATION_EMPLOYEE
      )
    ) {
      setIsAuthorisedUser(false);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (!isEmpty(personalDetails)) {
      handleAuthorisation();
    }
  }, [personalDetails]);

  return (
    <>
      {isLoading ? (
        <Loader className="mt-250 mb-250" />
      ) : isAuthorisedUser ? (
        <Outlet />
      ) : (
        <Navigate to="/404" />
      )}
    </>
  );
};

export default EmployeeRoutes;
